import { render, staticRenderFns } from "./AccountReset.vue?vue&type=template&id=73f8de01&scoped=true"
import script from "./AccountReset.vue?vue&type=script&lang=js"
export * from "./AccountReset.vue?vue&type=script&lang=js"
import style0 from "./AccountReset.vue?vue&type=style&index=0&id=73f8de01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f8de01",
  null
  
)

export default component.exports